import { useEffect, useState } from 'react';
import { useOfflineDownloadStatusStore } from '../offlineDownloadStatus.store';

export const useOfflineDownloadStatusStoreIsHydrated = () => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    if (useOfflineDownloadStatusStore.persist.hasHydrated()) {
      setIsHydrated(true);
      return;
    }

    const unsubscribe = useOfflineDownloadStatusStore.persist.onHydrate(() => {
      setIsHydrated(true);
    });

    return () => {
      unsubscribe();
    };
  }, []);

  return isHydrated;
};
